<template>
  <div class="content-item flex align-items-center">
    <div class="content-item-label">
      <span class="red">*</span>{{ name }}
    </div>
    <el-input
      id="selectRole"
      maxlength="50"
      show-word-limit
      placeholder="请输入名称"
      v-model="input"
    ></el-input>
  </div>
</template>

<script>
import publicTool from '@/utils/public';
export default {
  name: "diseaseName",
  props:['contentName', 'actionType'],
  data() {
    return {
      name: publicTool.actionTypeCheck(this.actionType) + '名称'
    }
  },
  computed: {
    input: {
      get() {
        return this.contentName
      },
      set(val) {
        this.$emit('update:contentName',val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
